import { BLOCKS } from "./richTextConstants"

export const tableRenderers = {
  [BLOCKS.TABLE]: (n, next) =>
    `<table><tbody>${next(n.content)}</tbody></table>`,
  [BLOCKS.TABLE_CELL]: (n, next) => `<td>${next(n.content)}</td>`,
  [BLOCKS.TABLE_HEADER_CELL]: (n, next) => `<th>${next(n.content)}</th>`,
  [BLOCKS.TABLE_ROW]: (n, next) => `<tr>${next(n.content)}</tr>`,
}
